import React from 'react';
import PropTypes from 'prop-types';

const HEADER_LABELS = [
  ['domain', 'Domain'],
  ['sec_fetch_site', 'Sec-Fetch-Site'],
  ['sec_ch_ua', 'Sec-CH-UA'],
  ['sec_ch_ua_platform', 'Sec-CH-UA-Platform'],
  ['accept_language', 'Accept-Language'],
];

const RequestHeaders = ({ headers }) => (
  <div className="column is-full">
    <strong>Headers:</strong>
    {headers && (
      <table className="table is-narrow is-size-7 mt-1">
        <tbody>
          {HEADER_LABELS.map(([key, label]) => (
            <tr key={key}>
              <th>{label}</th>
              <td className={headers[key] === undefined ? 'has-text-grey' : undefined}>
                {headers[key] === undefined ? 'not sent' : headers[key] || '(empty)'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

RequestHeaders.propTypes = {
  headers: PropTypes.object,
};

export default RequestHeaders;
